import * as React from "react";
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";
import { Item } from "@/types/fse";
import { FilesSelectTree } from "@/components/app/files-select-tree";
import { useNavigate } from "react-router";
import { ClipboardIcon } from "lucide-react";

interface Props {
  businessReport: BusinessReport;
  setIsOpen: (isOpen: boolean) => void;
}

export const BusinessReportSelectFileContent: React.FC<Props> = ({ businessReport, setIsOpen }) => {
  const [isLoading, setSetIsLoading] = React.useState<string>("");
  const handleClose = () => {
    setIsOpen(false);
  };
  const navigate = useNavigate();

  const handleFileAction = (item: { id: string }) => {
    navigate(`/reports/${item.id}?businessReport=${businessReport.id}`);
    setSetIsLoading(item.id);
  };

  return (
    <DialogContent className="flex h-[80vh] max-h-[600px] w-full max-w-[90vw] flex-grow flex-col">
      <DialogHeader>
        <DialogTitle>Select file to SnapShot</DialogTitle>
      </DialogHeader>
      <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
        <FilesSelectTree
          onAction={handleFileAction}
          folderActionButton={(item: Item) => (
            <Button
              variant="secondary"
              size="sm"
              className="w-full text-xs sm:w-auto"
              type="button"
              disabled={isLoading == item.id}
            >
              <ClipboardIcon className="mr-1 h-4 w-4" />
              {isLoading == item.id ? "Loading..." : "SnapShot"}
            </Button>
          )}
          actionButton={(item: Item) => (
            <Button
              variant="secondary"
              size="sm"
              className="w-full text-xs sm:w-auto"
              type="button"
              disabled={isLoading == item.id}
            >
              <ClipboardIcon className="mr-1 h-4 w-4" />
              {isLoading == item.id ? "Loading..." : "SnapShot"}
            </Button>
          )}
          showFiles={true}
          showFolders={true}
        />
      </div>
      <div className="mt-4 flex justify-between">
        <Button variant="outline" onClick={handleClose}>
          Cancel
        </Button>
      </div>
    </DialogContent>
  );
};
